<template>
    <section class="sidebarFilter">
        <p class="sidebarFilter__desc">
            {{ trans('EXTENDED_SEARCH_ACCURACY_FILTER_DESC') }}
        </p>
        <div class="sidebarFilter__wrapperRadioButton">
            <label class="sidebarFilter__container">
                <input
                    id="allWords"
                    :checked="checkAccuracyAll"
                    data-gtm="sidebarFilter__accuracy--all"
                    type="radio"
                    class="sidebarFilter__input"
                    tabindex="0"
                    @keyup.enter="selectAccuracy(all)"
                    @click="selectAccuracy(all)" />
                <span class="sidebarFilter__radioButton"></span>
                {{ trans('EXTENDED_SEARCH_ACCURACY_FILTER_TEXT_ALL') }}
            </label>
            <label class="sidebarFilter__container">
                <input
                    id="anyWords"
                    data-gtm="sidebarFilter__accuracy--any"
                    :checked="checkAccuracyAny"
                    type="radio"
                    class="sidebarFilter__input "
                    tabindex="0"
                    @keyup.enter="selectAccuracy(any)"
                    @click="selectAccuracy(any)" />
                <span class="sidebarFilter__radioButton"></span>
                {{ trans('EXTENDED_SEARCH_ACCURACY_FILTER_TEXT_ANY') }}
            </label>
        </div>
    </section>
</template>

<script>
    import Translator from 'tools/trans';
    import { useGetters } from 'composables/useVuex';
    export default {
        name: 'AccuracyFilter',
        data() {
            return {
                all: this.trans('EXTENDED_SEARCH_ACCURACY_FILTER_ALL'),
                any: this.trans('EXTENDED_SEARCH_ACCURACY_FILTER_ANY'),
                checkAccuracyAll: '',
                checkAccuracyAny: '',
            };
        },
        methods: {
            trans: Translator.trans,
            selectAccuracy(value) {
                if (value === this.all) {
                    this.checkAccuracyAll = true;
                    this.checkAccuracyAny = false;
                    this.$emit('selected-accuracy-text', this.all);
                    this.$parent.$emit('selected-accuracy', 'and');
                } else if (value === this.any) {
                    this.checkAccuracyAny = true;
                    this.checkAccuracyAll = false;
                    this.$emit('selected-accuracy-text', this.any);
                    this.$parent.$emit('selected-accuracy', 'or');
                }
            },
        },
        mounted() {
            if (this.accuracy === 'or') {
                this.checkAccuracyAny = true;
            } else {
                this.checkAccuracyAll = true;
            }
        },
        setup() {
            const getters = {
                ...useGetters('search', [
                    'accuracy',
                ]),
            };

            return {
                ...getters,
            };
        },
    };
</script>
